import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { useTabContext } from 'console/navigation/context';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { GraphsTabContent } from 'console/tabs/graphs/content';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { selectDevice } from 'entities/device/lib';
export const DashboardGraphs = memo(function DashboardGraphs() {
    const { device_id } = useDeviceConfig();
    const device = usePartialAppSelector(selectDevice, device_id);
    const { ui } = useTabContext();
    const legacy_device = useMemo(() => ui.devices.device(device_id), [device_id, ui.devices]);
    return (legacy_device &&
        device && (_jsx(GraphsTabContent, { large: isMediumUI(), device: legacy_device, ui: ui, r_device: device, active: true })));
});
